<!-- 生物药 -->
<template>
	<CommonTablePage
		type="bioDrug"
		title-value="生物药"
		placeholder="请输入名称/CAS号"
		:columns="columns"
		api-type="bio_drug"
	/>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CommonTablePage from "./components/CommonTablePage.vue";
defineOptions({
	name: "BioDrug"
});
const columns = ref([
	{
		prop: "name",
		label: "名称"
	},
	{
		prop: "casNumber",
		label: "CAS号"
	},
	{
		prop: "verificationStatus",
		label: "验证状态"
	},
	{
		prop: "purity",
		label: "纯度"
	}
]);
</script>